// LanguageSelector.jsx
import React, { useEffect, useState } from "react";

const LanguageSelector = () => {
  const [isTranslateReady, setIsTranslateReady] = useState(false);
  const [showSelector, setShowSelector] = useState(true);

  const languageMap = {
    en: "English",
    es: "Spanish",
    pt: "Portuguese",
    it: "Italian",
    de: "German",
    "zh-CN": "Mandarin",
    ja: "Japanese",
    ru: "Russian",
    fr: "French",
  };

  // Auto-select language if detected
  useEffect(() => {
    console.log("[LanguageSelector] Component mounted");

    const browserLang = navigator.language || navigator.userLanguage;
    const shortLang = browserLang.split("-")[0]; // e.g., "en-US" -> "en"
    console.log(`[LanguageSelector] Detected browser language: ${browserLang}`);

    const interval = setInterval(() => {
      const combo = document.querySelector("#google_translate_element select");

      if (combo) {
        console.log("[LanguageSelector] Google Translate dropdown detected.");
        setIsTranslateReady(true);
        clearInterval(interval);

        const langKey = Object.keys(languageMap).find((key) =>
          browserLang.startsWith(key)
        );

        if (langKey) {
          console.log(
            `[LanguageSelector] Auto-setting language to ${languageMap[langKey]}`
          );
          changeLanguage(languageMap[langKey], true); // pass 'true' to indicate auto
        } else {
          console.log(
            "[LanguageSelector] No matching language found for browser setting."
          );
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const changeLanguage = (lang, auto = false) => {
    console.log(`[LanguageSelector] Attempting to change language to: ${lang}`);
    const combo = document.querySelector("#google_translate_element select");

    if (!combo) {
      console.warn("[LanguageSelector] No dropdown combo found.");
      alert("Google Translate is still loading. Please wait.");
      return;
    }

    const reverseMap = {
      English: "en",
      Spanish: "es",
      Portuguese: "pt",
      Italian: "it",
      German: "de",
      Mandarin: "zh-CN",
      Japanese: "ja",
      Russian: "ru",
      French: "fr",
    };

    const value = reverseMap[lang];
    if (!value) {
      console.error(`[LanguageSelector] Language ${lang} not supported.`);
      return;
    }

    combo.value = value;
    combo.dispatchEvent(new Event("change")); // Trigger Google Translate
    console.log(`[LanguageSelector] Language set to: ${lang} (${value})`);

    if (!auto) {
      setShowSelector(false); // only hide if user manually selects
    }
  };

  return (
    <>
      <div id="google_translate_element" style={{ display: "none" }}></div>

      {showSelector && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm w-full">
            <h2 className="text-lg font-semibold mb-4">What language?</h2>
            <div className="flex flex-col gap-3">
              {Object.values(languageMap).map((lang) => (
                <button
                  key={lang}
                  disabled={!isTranslateReady}
                  onClick={() => changeLanguage(lang)}
                  className={`px-4 py-2 rounded ${
                    isTranslateReady
                      ? "bg-blue-500 text-white hover:bg-blue-600"
                      : "bg-gray-400 text-gray-200 cursor-not-allowed"
                  }`}
                >
                  {lang}
                </button>
              ))}
            </div>
            {!isTranslateReady && (
              <p className="text-gray-500 text-sm mt-3">
                Loading translation... (Check console logs)
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default LanguageSelector;
